import { useMemo } from "react";
import { STATUSES } from "../../lib/api";

export const StatusUpdatePanel = ({ order, targetStatus, setTargetStatus, note, setNote, updateStatus, saving, needsDispatchForm }) => {
  const statusOptions = useMemo(() => STATUSES.filter((s) => s.value !== order.status), [order.status]);
  return (
  <div className="rounded-md border border-slate-200 bg-white p-5" data-testid="status-update-panel">
    <h2 className="text-base font-bold text-slate-900 md:text-lg">Update Status</h2>
    <select data-testid="status-select" value={targetStatus} onChange={(e) => setTargetStatus(e.target.value)}
      className="mt-3 w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm outline-none">
      <option value="">Select new status…</option>
      {statusOptions.map((s) => (
        <option key={s.value} value={s.value}>{s.label}</option>
      ))}
    </select>
    {needsDispatchForm && (
      <p className="mt-2 rounded-md border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-700">
        Fill dispatch details (left panel) — date, transporter, vehicle and LR number are required to mark as Dispatched.
      </p>
    )}
    <input data-testid="status-note-input" value={note} onChange={(e) => setNote(e.target.value)}
      placeholder="Optional note…"
      className="mt-3 w-full rounded-md border border-slate-300 px-3 py-2 text-sm outline-none transition-colors duration-150 focus:border-slate-900" />
    <button data-testid="update-status-button" onClick={updateStatus} disabled={!targetStatus || saving}
      className="mt-3 w-full rounded-md bg-slate-900 px-4 py-2 text-sm font-semibold text-white transition-colors duration-150 hover:bg-slate-700 disabled:opacity-50">
      {saving ? "Updating…" : "Update status"}
    </button>
  </div>
  );
};
